// extracted by mini-css-extract-plugin
export default {"container":"see-more-see-less_container__93CRL","button":"see-more-see-less_button__YAFd8"};